<template>
    <a-select :value="passwaycode" placeholder="输入通道名称"  style="width: 150px"
         :filter-option="true" :not-found-content="null" 
        @change="handleChange">
        <a-select-option v-for="d in passwayList" :key="d.value" :disabled="d.status == '01'">
            {{ d.text }}
        </a-select-option>
    </a-select>

</template>
<script>
export default {
    data() {
        return {
            passwayList: [],
            passwaycode: '',
        }
    },

    props: {
        channelcode: String
    },

    methods: {

        handleChange(value) {
            let targetData = this.passwayList.filter((item) => {
                return item.value == value
            });
            if (targetData.length > 0) {
                this.passwaycode = targetData[0].value;
                this.$emit('onPasswayCodeChange', targetData[0]);
            }
        },
        doSearch() {
            let that = this;
            let c_params = {
                urlparams: false,
                channelcode: this.channelcode,
            }

            that.$store.dispatch({
                type: "mcmsmanager/getpasswaybychannel",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    that.passwayList = [];
                    let result = res.data.data;
                    if (!result) {
                        that.message.error("未查询到渠道");
                        return;
                    }
                    let firstCode = '';
                    result.forEach(r => {
                        if(firstCode == '' && r.status == '02'){
                            firstCode = r.passwaycode
                        }
                        that.passwayList.push({
                            value: r.passwaycode,
                            text: r.passwayname,
                            passwaytype:r.passwaytype,
                            passwaytypename:r.passwaytypename,
                            status:r.status
                        });
                    });
                    if(firstCode){
                        that.passwaycode = firstCode
                        that.handleChange(that.passwaycode)
                    }
                    else{
                        that.passwayList = [];
                        that.passwaycode = ''
                        // that.message.error("当前渠道没有可用通道！！")
                    }
                   
                }
            }).catch(() => {

            });
        },

    },
    mounted() {},
    watch: {
        'channelcode'(newVal) {
            if (newVal) {
                this.doSearch();
            }
        }
    },
};
</script>

<style scoped>

</style>